// Programma-metadata voor Stichting FIN. Één bron van waarheid voor:
// - navigatie / anchor-links (id)
// - project-filters (key = theme in backend)
// - kaarten op home / wat-we-doen
// - kleuraccenten per programma
import { LifeBuoy, ShieldCheck, Sparkles, Users } from "lucide-react";

export const PROGRAMS = [
  {
    key: "herstel",
    anchorId: "herstel",
    label: "FIN Herstel",
    subtitle: "Van vastlopen naar weer overzicht.",
    icon: LifeBuoy,
    short:
      "Praktische en persoonlijke ondersteuning voor mensen die zijn vastgelopen in complexe maatschappelijke of financiële situaties.",
    long:
      "Binnen FIN Herstel bieden wij één-op-één ondersteuning aan mensen die door omstandigheden — waaronder de toeslagenaffaire — het overzicht kwijt zijn. We ordenen samen wat speelt, bereiden gesprekken voor en zetten concrete stappen richting herstel.",
    highlights: [
      "Overzicht creëren in complexe situaties",
      "Administratie ordenen",
      "Gesprekken met instanties voorbereiden",
      "Praktische coaching en hersteldoelen",
      "Doorverwijzen naar specialistische hulp waar nodig",
    ],
    image:
      "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=1400&q=80",
    imageAlt: "Begeleider en cliënt bekijken samen documenten aan een lichte tafel",
  },
  {
    key: "bestaanszekerheid",
    anchorId: "bestaanszekerheid",
    label: "FIN Bestaanszekerheid",
    subtitle: "Problemen aanpakken voordat ze groter worden.",
    icon: ShieldCheck,
    short:
      "Preventieve en praktische ondersteuning bij financiële problemen, dreigende dakloosheid en toegang tot passende hulp.",
    long:
      "FIN Bestaanszekerheid richt zich op vroeg ingrijpen. We werken samen met lokale organisaties om financiële problemen te ontrafelen, dakloosheid te helpen voorkomen en mensen weer op weg te helpen naar passende ondersteuning — voordat één probleem uitgroeit tot vele.",
    highlights: [
      "Armoedebestrijding",
      "Preventie van dakloosheid",
      "Ondersteuning bij dreigende escalatie",
      "Toegang tot passende hulp",
      "Samenwerking met lokale organisaties",
    ],
    image:
      "https://images.unsplash.com/photo-1609220136736-443140cffec6?auto=format&fit=crop&w=1400&q=80",
    imageAlt: "Persoon in alledaagse Nederlandse omgeving met ontspannen blik",
  },
  {
    key: "groei-kansen",
    anchorId: "groei-kansen",
    label: "FIN Groei & Kansen",
    subtitle: "Talent verdient ruimte.",
    icon: Sparkles,
    short:
      "Projecten voor jongeren en gezinnen rond talentontwikkeling, participatie en persoonlijke groei — zodat omstandigheden geen plafond zijn.",
    long:
      "Omstandigheden mogen niet bepalen welke mogelijkheden iemand later heeft. FIN Groei & Kansen investeert in jongeren en gezinnen via educatieve projecten, participatietrajecten en empowerment — met programma's die aansluiten bij wat mensen zelf willen ontdekken en ontwikkelen.",
    highlights: [
      "Jongeren en talentontwikkeling",
      "Participatie en persoonlijke groei",
      "Educatieve projecten",
      "Empowerment en zelfvertrouwen",
      "Maatschappelijke kansen",
    ],
    image:
      "https://images.unsplash.com/photo-1529390079861-591de354faf5?auto=format&fit=crop&w=1400&q=80",
    imageAlt: "Jongeren samen creatief bezig in een lichte ruimte",
  },
  {
    key: "community",
    anchorId: "community",
    label: "FIN Community",
    subtitle: "Sterke mensen beginnen bij sterke gemeenschappen.",
    icon: Users,
    short:
      "Projecten die de leefomgeving versterken — in Nederland én in het Caribisch deel van het Koninkrijk. Van gemeenschapsinitiatieven tot veilige speelplekken.",
    long:
      "FIN Community investeert in sterke leefomgevingen. We ondersteunen buurtprojecten, gemeenschapsinitiatieven en samenwerkingen die bijdragen aan sociale cohesie. Ook internationale community-projecten passen hierbij — zoals de verkenning van een veilige speelplek op Curaçao samen met lokale partners.",
    highlights: [
      "Buurt- en gemeenschapsprojecten",
      "Sociale cohesie",
      "Veilige leefomgevingen",
      "Internationale community-projecten",
      "Speelruimte Curaçao (in verkenning)",
    ],
    image:
      "https://images.unsplash.com/photo-1602052793312-b99c2cb3b805?auto=format&fit=crop&w=1400&q=80",
    imageAlt: "Kinderen die buiten spelen in een levendige buurt met warm zonlicht",
  },
];

export const PROGRAM_BY_KEY = Object.fromEntries(PROGRAMS.map((p) => [p.key, p]));

export const PROJECT_STATUS_LABEL = {
  idee: "Idee",
  "in-ontwikkeling": "In ontwikkeling",
  actief: "Actief",
  afgerond: "Afgerond",
};

export const PROJECT_STATUS_COLOR = {
  idee: "text-goldDark",
  "in-ontwikkeling": "text-amber-700",
  actief: "text-emerald-700",
  afgerond: "text-ink/60",
};
